import React from 'react';
import styles from './Intuitive2.module.css';

import asset4 from '../../../assets/orange_poly.png';
import asset5 from '../../../assets/green_poly.png';
const Intuitive2 = () => {
  return (
    <section className={styles.intuitive2Section}>
      <div className={styles.textContainer}>

<img src={asset4} alt="Asset 4" className={styles.orangePoly} />
<img src={asset5} alt="Asset 5" className={styles.greenPoly} />
        <h2 className={styles.line1}>AI generated ice breakers</h2>
        <h2 className={styles.line2}>We know that sometimes it's hard to find the right words to say, especially when first approaching someone.</h2>
        <h2 className={styles.line3}>We use AI to give you personalized ice breaker suggestions based on your shared interests and preferences.<br/>You just set the tone. </h2>
      </div>
    </section>
  );
};

export default Intuitive2;
